// Organization changes labels/order, never price or supplier evidence.
export const MATERIAL_CATEGORIES = [
  "Panels and breakers", "Building wire and cable", "Lighting and controls",
  "Receptacles and dedicated outlets", "Boxes, plates and weatherproof covers",
  "Equipment disconnects and whips", "Smoke and carbon monoxide alarms",
  "Fire-alarm equipment", "Emergency lighting and exit signs", "Data and communications",
  "Grounding and bonding", "Design, testing and commissioning",
  "Installation connectors and consumables", "Other materials",
];
export const WORK_PHASE_NAMES = ["Service and distribution", "Rough-in", "Finishing", "Commissioning"];
export function materialCategory(m) { return String(m.material_category || m.section || "").trim(); }
export function suggestMaterialCategory(m) {
  const t = String(m.description || m.sku || "").toLowerCase();
  if (/specialist|verification|programming|submission|certificate setup|design.*allowance/.test(t)) return MATERIAL_CATEGORIES[11];
  if (/exit|emergency.light|remote.head|running.man/.test(t)) return MATERIAL_CATEGORIES[8];
  if (/smoke.{0,20}(co|carbon)|kidde|first alert|dwelling.alarm|hardwired smoke alarm/.test(t) && !/box|connector|cable|wire/.test(t)) return MATERIAL_CATEGORIES[6];
  if (/fire.alarm|secutron|horn.strobe|pull station|detector|annunciator|communicator|nac|12v.*battery/.test(t) && !/cable|wire|box|fitting|support|firestop/.test(t)) return MATERIAL_CATEGORIES[7];
  if (/box|plate|cover|enclosure/.test(t) && !/panelboard|load.cent/.test(t)) return MATERIAL_CATEGORIES[4];
  if (/connector|fitting|strap|staple|fastener|consumable|termination|support|firestop|gland/.test(t) && !/breaker|load.cent/.test(t)) return MATERIAL_CATEGORIES[12];
  if (/ground|bond|neutral lug/.test(t) && !/cable|wire/.test(t)) return MATERIAL_CATEGORIES[10];
  if (/disconnect|whip/.test(t)) return MATERIAL_CATEGORIES[5];
  if (/cat.?[56]|data|ethernet|television|coax|network/.test(t)) return MATERIAL_CATEGORIES[9];
  if (/nmd|nmwu|acwu|teck|rw90|soow|cable|wire/.test(t) && !/receptacle|breaker|panel|hardwire/.test(t)) return MATERIAL_CATEGORIES[1];
  if (/load.cent|panelboard|main.breaker|^q[a-z0-9]*\d|breaker/.test(t) && !/priced separately|itemized separately|fitting/.test(t)) return MATERIAL_CATEGORIES[0];
  if (/receptacle|outlet|gfci/.test(t)) return MATERIAL_CATEGORIES[3];
  if (/light|switch|dimmer|timer|control/.test(t)) return MATERIAL_CATEGORIES[2];
  if (/fitting|connector|support|termination|consumable/.test(t)) return MATERIAL_CATEGORIES[12];
  return MATERIAL_CATEGORIES[13];
}
function defaultMaterialCategory(m) {
  if (m.material_category) return m.material_category;
  const section = String(m.section || "").trim();
  const phaseLabel = /^(?:part\s*\d+\s*[—–:-]\s*)?(?:electrical|fire[ -]alarm|rough[ -]?in|finishing|service(?: and distribution)?|commissioning|phase\s*\d+)$/i;
  return section && !phaseLabel.test(section) ? section : suggestMaterialCategory(m);
}
// Keep lots intact even when an earlier edit left their members non-contiguous.
export function organizeMaterials(materials, categoryFor = defaultMaterialCategory) {
  const rows = Array.isArray(materials) ? materials : [];
  const anchors = new Map(rows.filter(m => m._lot?.id).map(m => [m._lot.id, m]));
  const seen = new Set(), groups = new Map();
  function append(block, label) {
    if (!groups.has(label)) groups.set(label, []);
    groups.get(label).push(...block.map(m => ({ ...m, material_category: label })));
  }
  for (let i = 0; i < rows.length; i++) {
    if (seen.has(i)) continue;
    const m = rows[i];
    if (m._lot_member && anchors.has(m._lot_member)) continue;
    const block = [m]; seen.add(i);
    if (m._lot?.id) rows.forEach((child, j) => { if (child._lot_member === m._lot.id) { block.push(child); seen.add(j); } });
    append(block, String(categoryFor(m) || "Other materials").trim());
  }
  // Orphan members are retained as ordinary rows, not hidden or dropped.
  rows.forEach((m, i) => { if (!seen.has(i)) append([m], String(categoryFor(m) || "Other materials").trim()); });
  const rank = k => { const n = MATERIAL_CATEGORIES.indexOf(k); return n < 0 ? MATERIAL_CATEGORIES.length : n; };
  return [...groups].sort((a, b) => rank(a[0]) - rank(b[0])).flatMap(([, ms]) => ms);
}

export function assignMaterialCategory(materials, selectedIds, label) {
  const selected = new Set(selectedIds), lots = new Set();
  materials.forEach(m => { if (selected.has(m.id || `row_${materials.indexOf(m)}`)) { if (m._lot?.id) lots.add(m._lot.id); if (m._lot_member) lots.add(m._lot_member); } });
  return organizeMaterials(materials, m => selected.has(m.id || `row_${materials.indexOf(m)}`) || lots.has(m._lot?.id) || lots.has(m._lot_member)
    ? label : defaultMaterialCategory(m));
}
export function isScopeHeading(row) {
  return row?.is_heading === true || (row?.is_heading !== false && !row?.subsection && /:$/.test(String(row?.text || "").trim()) && String(row.text).length < 100);
}
